import React from 'react';
import classNames from 'classnames';

interface UserBannerWrapperProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  className?: string;
  variant?: 'vertical' | 'auto';
}

export const BannerWrapper: React.FC<UserBannerWrapperProps> = ({
  children,
  icon,
  className,
  variant = 'auto',
}) => {
  return (
    <article
      className={classNames(
        'p-6 flex items-center gap-6 rounded-2xl',
        {
          'flex-col md:flex-row': variant === 'auto',
          'flex-col': variant === 'vertical',
        },
        className
      )}
    >
      <div className="min-w-full flex justify-center md:min-w-[25%] xl:min-w-[200px]">
        {icon}
      </div>
      <div
        className={classNames('flex flex-col items-center text-center gap-6', {
          'md:items-start md:text-left': variant === 'auto',
        })}
      >
        {children}
      </div>
    </article>
  );
};
